<template>
  <div class="ser-1">
    <div class="record-1">
      <div class="record-2">
        <div>
          <el-button type="primary" @click="clearData">刷新</el-button>
        </div>
        <div>
          <el-button type="primary" @click="detailsRecord">查看工单</el-button>
        </div>
        <div>
          <el-button type="primary">发送短信</el-button>
        </div>
        <div>
          <el-button type="primary">催单</el-button>
        </div>
      </div>
      <div>
        <el-button type="danger" @click="deleteilsRecord">废除工单</el-button>
      </div>
    </div>
    <!-- @selection-change='handleSelectionChange' -->
    <div class="record-3">
      <el-table
        :data="tableData"
        border
        style="width: 80%"
        ref="multipleTable"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column width="55" align="center" label="">
          <template slot-scope="scope">
            <el-radio
              :label="scope.row.id"
              v-model="templateRadio"
              @change.native="getTemplateRow(scope.$index, scope.row)"
            >
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单号"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="states"
          label="工单状态"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.states == 0">待派发</span>
            <span v-if="scope.row.states == 1">待处理</span>
            <span v-if="scope.row.states == 2">待回访</span>
            <span v-if="scope.row.states == 3">服务完成</span>
            <span v-if="scope.row.states == 4">待作废</span>
            <span v-if="scope.row.states == 5">已作废</span>
            <span v-if="scope.row.states == 100">移动终端接单</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="服务地址"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeStart"
          label="服务日期"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="serveproductName"
          label="服务项目"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="price"
          label="套餐金额"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="visitContent"
          label="服务内容"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servePersonName"
          label="服务人员 "
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servePersonPhone"
          label="服务人员电话 "
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="project"
          label="催单次 "
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-page">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="query.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      class="dialog_container"
    >
      <div class="dia-1">
        <div style="width: 90%" class="diass">
          <el-form label-width="180px" :model="normalInfo">
            <div class="navMenu">
              <el-button
                :type="displayIndex === 0 ? 'primary' : 'info'"
                @click="infoTap(0)"
                >客户信息
              </el-button>
              <el-button
                :type="displayIndex === 1 ? 'primary' : 'info'"
                @click="infoTap(1)"
                >服务工单
              </el-button>
              <el-button
                :type="displayIndex === 2 ? 'primary' : 'info'"
                @click="infoTap(2)"
                >服务人员
              </el-button>
              <el-button
                :type="displayIndex === 3 ? 'primary' : 'info'"
                @click="infoTap(3)"
                >处理信息
              </el-button>
              <el-button
                :type="displayIndex === 4 ? 'primary' : 'info'"
                @click="infoTap(4)"
                >回访信息
              </el-button>
            </div>
            <!-- <div style="height: 12px; margin-top: 30px; color: #169bd5">
              客户信息
            </div> -->
            <!-- <el-divider></el-divider> -->
            <div class="desBox" v-if="displayIndex === 0">
              <div style="width: 50%">
                <el-form-item label="客户信息：">
                  <el-input
                    size="small"
                    v-model="normalInfo.customerName"
                    style="width: 80%"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人：">
                  <el-input
                    size="small"
                    style="width: 80%"
                    v-model="normalInfo.customerName"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系方式一：">
                  <el-input
                    size="small"
                    style="width: 80%"
                    v-model="normalInfo.customerphone"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="联系方式二："
                  v-if="normalInfo.otherTelephone == 1"
                >
                  <el-input
                    size="small"
                    style="width: 80%"
                    v-model="normalInfo.familyPhone"
                    disabled
                  ></el-input>
                </el-form-item>
              </div>
              <div style="width: 50%">
                <el-form-item label="客户类型：">
                  <el-select
                    style="width: 80%"
                    v-model="normalInfo.customerType"
                    placeholder="请选择"
                    size="medium"
                    disabled
                  >
                    <el-option label="商业服务工单" value="7"></el-option>
                    <el-option label="残联服务工单" value="3"></el-option>
                    <el-option label="老干服务工单" value="4"></el-option>
                    <el-option label="民政服务工单" value="6"></el-option>
                    <el-option label="文明办服务工单" value="10"></el-option>
                    <!-- <el-option label="信息回访服务工单" value="9"></el-option> -->
                  </el-select>
                </el-form-item>
                <el-form-item label="是否需要其他联系方式：">
                  <el-select
                    style="width: 80%"
                    v-model="normalInfo.otherTelephone"
                    placeholder="请选择"
                    size="medium"
                    disabled
                  >
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系地址：">
                  <el-input
                    size="small"
                    style="width: 80%"
                    v-model="normalInfo.address"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系地址：" v-show="qtlxfs">
                  <el-input
                    size="small"
                    style="width: 80%"
                    v-model="normalInfo.currentAddress"
                    disabled
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <!--  -->
            <div class="desBox" v-if="displayIndex === 1">
              <div style="width: 50%">
                <el-form-item label="套餐类型：">
                  <el-select
                    v-model="normalInfo.ensure"
                    disabled
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in ensureList"
                      :key="item.id"
                      :label="item.mealType"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="服务类别：">
                  <el-input
                    disabled
                    v-model="normalInfo.servetypename"
                    style="width: 80%"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="计划时间：">
                  <el-date-picker
                    style="width: 80%"
                    v-model="normalInfo.sertime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    disabled
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="计划时间"
                    size="medium"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <div style="width: 50%">
                <el-form-item label="服务时长：">
                  <el-input
                    disabled
                    v-model="normalInfo.period"
                    style="width: 80%"
                    size="medium"
                    ><i slot="suffix">分钟</i></el-input
                  >
                </el-form-item>
                <el-form-item label="服务项目：">
                  <el-checkbox-group
                    v-model="normalInfo.serveproductName"
                    disabled
                  >
                    <el-checkbox
                      v-for="data in tableProject"
                      :label="data.id"
                      :key="data.id"
                    >
                      {{ data.serviceProductName }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <el-form-item label="其他说明：">
                <el-input
                  v-model="normalInfo.otherDesc"
                  size="medium"
                  type="textarea"
                  disabled
                  style="width: 90%"
                ></el-input>
              </el-form-item>
            </div>

            <!-- <div style="height: 12px; margin-top: 30px; color: #169bd5">
              服务人员
            </div> -->
            <!-- <el-divider></el-divider> v-if="displayIndex === 2"-->
            <div class="desBox" v-if="displayIndex === 2">
              <div style="width: 50%">
                <el-form-item label="机构：">
                  <el-input
                    disabled
                    v-model="normalInfo.servestationName"
                    size="medium"
                    style="width: 80%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="服务人员：">
                  <el-input
                    disabled
                    v-model="normalInfo.servePersonName"
                    size="medium"
                    style="width: 80%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否有加盟商：">
                  <el-radio-group v-model="normalInfo.franchisee" disabled>
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否有从属服务人员：">
                  <el-radio-group v-model="normalInfo.otherPerson" disabled>
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否有志愿者：">
                  <el-radio-group v-model="normalInfo.volunteer" disabled>
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div style="width: 50%">
                <el-form-item label="站点类型：">
                  <el-select
                    disabled
                    style="width: 80%"
                    v-model="normalInfo.statType"
                    placeholder="请选择"
                    size="medium"
                  >
                    <el-option label="居家养老机构" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系方式：">
                  <el-input
                    disabled
                    v-model="normalInfo.servePersonPhone"
                    style="width: 80%"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="加盟商：" v-show="franchisee">
                  <el-input
                    disabled
                    v-model="normalInfo.jiamengEstimate"
                    style="width: 80%"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="服务人员：" v-show="otherServePerson">
                  <el-input
                    disabled
                    v-model="normalInfo.otherservePersonName"
                    style="width: 80%"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="志愿者：" v-show="volunteer">
                  <el-input
                    disabled
                    v-model="normalInfo.otherReturnContent"
                    style="width: 80%"
                    size="medium"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div
              v-if="this.normalInfo.stats != '' && this.normalInfo.stats != '1'"
            >
              <!-- <div style="height: 12px; margin-top: 30px; color: #169bd5">
                处理信息
              </div>
              <el-divider></el-divider> -->
              <div class="desBox" v-if="displayIndex === 3">
                <el-form-item label="APP用户反馈语音评价1：">
                  <el-input
                    v-model="normalInfo.evaluate"
                    style="width: 80%"
                    disabled
                  ></el-input>
                </el-form-item>
                <audio
                  style="margin-left: 15%; margin-bottom: 20px"
                  controls="controls"
                  preload="auto"
                  class="audioActive"
                  :src="normalInfo.estimateRecord"
                ></audio>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开始时间：">
                      <el-date-picker
                        disabled
                        v-model="normalInfo.timeStart"
                        type="datetime"
                        style="width: 80%"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="结束时间：">
                      <el-date-picker
                        disabled
                        v-model="normalInfo.timeEnd"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 80%"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="服务内容：">
                  <el-input
                    type="textarea"
                    style="width: 80%"
                    disabled
                    v-model="normalInfo.visitContent"
                  ></el-input>
                </el-form-item>
                <el-form-item label="工作图片：">
                  <el-row :gutter="10">
                    <el-col :span="6" class="imgBox">
                      <img
                        v-if="normalInfo.picStart"
                        style="width: 80%"
                        :src="normalInfo.picStart"
                        alt="工作开始图片"
                      />
                      <div>工作开始</div>
                    </el-col>
                    <el-col :span="6" class="imgBox">
                      <img
                        v-if="normalInfo.picFinished"
                        style="width: 80%"
                        :src="normalInfo.picFinished"
                        alt="工作结束图片"
                      />
                      <div>工作结束</div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
            </div>
            <div v-if="this.normalInfo.stats != ''">
              <div class="desBox" v-if="displayIndex === 4">
                <!-- <div style="height: 12px; margin-top: 30px; color: #169bd5">
                  回访信息
                </div>
                <el-divider></el-divider> -->
                <div style="width: 50%">
                  <el-form-item label="客户名称：">
                    <el-input
                      disabled
                      v-model="normalInfo.customerName"
                      style="width: 80%"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="是否通过App处理工单：" prop="fromApps">
                    <el-radio-group
                      disabled
                      v-model="normalInfo.fromApps"
                      style="width: 80%"
                    >
                      <el-radio label="0">是</el-radio>
                      <el-radio label="1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="服务时间是否符合规范：" prop="rightTime">
                    <el-radio-group
                      disabled
                      v-model="normalInfo.rightTime"
                      style="width: 80%"
                    >
                      <el-radio label="0">是</el-radio>
                      <el-radio label="1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="服务对象评价：">
                    <el-input
                      type="textarea"
                      style="width: 80%"
                      disabled
                      v-model="normalInfo.estimate"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客户满意度：" style="width: 80%">
                    <el-select
                      disabled
                      v-model="normalInfo.estimateLevel"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in estimateLevelList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="回访结果：">
                    <el-radio-group disabled v-model="normalInfo.results">
                      <el-radio label="0">合格</el-radio>
                      <el-radio label="1">不合格</el-radio>
                      <el-radio label="2">作废</el-radio>
                      <el-radio label="3">虚假工单</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div style="width: 50%">
                  <el-form-item label="联系方式：">
                    <el-input
                      disabled
                      v-model="normalInfo.customerphone"
                      style="width: 80%"
                    ></el-input>

                    <i class="el-icon-phone phoneCall" title="电话"></i>
                  </el-form-item>
                  <el-form-item label="上传图片是否符合规范：" prop="rightPic">
                    <el-radio-group
                      v-model="normalInfo.rightPic"
                      style="width: 80%"
                      disabled
                    >
                      <el-radio label="0">是</el-radio>
                      <el-radio label="1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    label="是否上传语音评价："
                    prop="rightEstimateRecord"
                  >
                    <el-radio-group
                      disabled
                      v-model="normalInfo.rightEstimateRecord"
                      style="width: 80%"
                    >
                      <el-radio label="0">是</el-radio>
                      <el-radio label="1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="服务企业（组织）评价：">
                    <el-input
                      type="textarea"
                      disabled
                      style="width: 80%"
                      v-model="normalInfo.jiamengEstimate"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="是否上门：">
                    <el-radio-group
                      disabled
                      v-model="normalInfo.visited"
                      style="width: 80%"
                    >
                      <el-radio :label="0">是</el-radio>
                      <el-radio :label="1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="理由：">
                    <el-input
                      type="textarea"
                      disabled
                      v-model="normalInfo.reason"
                      style="width: 80%"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="dia-4" v-if="setpInfo.length > 0">
          <div class="datas" v-for="(item, index) in setpInfo" :key="index">
            <div class="recondItem" v-if="item.states == 0">
              <div
                class="recondeLine"
                :class="item.currIndex == true ? 'recondeLine1' : ''"
              ></div>
              <div
                class="recondeDot"
                :class="item.currIndex == true ? 'recondeDot1' : ''"
              >
                新
              </div>
              <div
                class="recondeBgs"
                :class="item.currIndex == true ? 'recondeBg1' : ''"
              >
                <p class="recondeTitle">新建工单</p>
                <ul class="recondeUl">
                  <li>时间：{{ item.createTime }}</li>
                  <li>工单类型：{{ item.pgdtypeName }}</li>
                  <li>套餐类型：{{ item.ensureName }}</li>
                </ul>
              </div>
            </div>
            <div class="recondItem" v-if="item.states == 10">
              <div
                class="recondeLine"
                :class="item.currIndex == true ? 'recondeLine1' : ''"
              ></div>
              <div
                class="recondeDot"
                :class="item.currIndex == true ? 'recondeDot1' : ''"
              >
                开
              </div>
              <div
                class="recondeBg"
                :class="item.currIndex == true ? 'recondeBg1' : ''"
              >
                <p class="recondeTitle">开始服务</p>
                <ul class="recondeUl">
                  <li>时间：{{ item.palnTimeStart }}</li>
                  <li>服务人员：{{ item.servePersonName }}</li>
                </ul>
              </div>
            </div>
            <div class="recondItem" v-if="item.states == 11">
              <div
                class="recondeLine"
                :class="item.currIndex == true ? 'recondeLine1' : ''"
              ></div>
              <div
                class="recondeDot"
                :class="item.currIndex == true ? 'recondeDot1' : ''"
              >
                结
              </div>
              <div
                class="recondeBg"
                :class="item.currIndex == true ? 'recondeBg1' : ''"
              >
                <p class="recondeTitle">结束服务</p>
                <ul class="recondeUl">
                  <li>时间：{{ item.palnTimeEnd }}</li>
                  <li>服务时长：{{ item.period }}分钟</li>
                  <li>服务内容：{{ item.visitContent }}</li>
                </ul>
              </div>
            </div>

            <div class="recondItem" v-if="item.states == 7">
              <div class="recondeLine recondeLine1"></div>
              <div class="recondeDot recondeDot1">异</div>
              <div class="recondeBg recondeBg1">
                <p class="recondeTitle">异常工单</p>
                <ul class="recondeUl">
                  <li>异常类型：{{ item.exceptionStatusName }}</li>
                </ul>
              </div>
            </div>
            <div class="recondItem" v-if="item.states == 13">
              <div
                class="recondeLine"
                :class="item.currIndex == true ? 'recondeLine1' : ''"
              ></div>
              <div
                class="recondeDot"
                :class="item.currIndex == true ? 'recondeDot1' : ''"
              >
                处
              </div>
              <div
                class="recondeBg"
                :class="item.currIndex == true ? 'recondeBg1' : ''"
              >
                <p class="recondeTitle">处置结果</p>
                <ul class="recondeUl">
                  <li>时间：{{ item.createTime }}</li>
                  <li>处置类型：{{ item.processStatusName }}</li>
                  <li>处置人：{{ item.createdId }}</li>
                </ul>
              </div>
            </div>
            <div class="recondItem" v-if="item.states == 14">
              <div
                class="recondeLine"
                :class="item.currIndex == true ? 'recondeLine1' : ''"
              ></div>
              <div
                class="recondeDot"
                :class="item.currIndex == true ? 'recondeDot1' : ''"
              >
                回
              </div>
              <div
                class="recondeBg"
                :class="item.currIndex == true ? 'recondeBg1' : ''"
              >
                <p class="recondeTitle">回访工单</p>
                <ul class="recondeUl">
                  <li>时间：{{ item.callTime }}</li>
                  <li>客服满意度：{{ item.estimateLevelName }}</li>
                  <li>回访结果：合格</li>
                  <!-- <li>回访结果：{{ item.resultsName }}</li> -->
                </ul>
              </div>
            </div>
          </div>
          <!-- <div class="block">
                        <el-timeline>
                            <el-timeline-item
                                class="recondItem"
                            ></el-timeline-item> -->

          <!-- <el-timeline-item
                                v-for="(activity, index) in activities"
                                :key="index"
                                icon="el-icon-more"
                                type="primary"
                                color="red"
                                size="normal"
                            >
                                <div class="server-1">
                                    <p>{{ activity.content }}</p>
                                    <p class="server-2">
                                        {{ activity.name1 }}:{{
                                            activity.name2
                                        }}
                                    </p>
                                    <p class="server-2">
                                        {{ activity.name3 }}:{{
                                            activity.name4
                                        }}
                                    </p>
                                    <p class="server-2">
                                        状态：{{ activity.name5 }}
                                    </p>
                                </div>
                            </el-timeline-item> -->
          <!-- </el-timeline> -->
          <!-- </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request.js"

export default {
  props: {
    formData: {},
  },
  data() {
    return {
      displayIndex: 0,
      timeTitle: "",
      templateRadio: "",
      currIndex: false,
      estimateLevelList: [
        { value: "0", label: "未评价" },
        { value: "1", label: "没有服务" },
        { value: "2", label: "不满意" },
        { value: "3", label: "服务一般" },
        { value: "4", label: "基本满意" },
        { value: "5", label: "非常满意" },
      ],
      serviceTypeList: [],
      multipleSelection: [],
      ensureList: [],
      query: {
        pageNo: 1,
        pageSize: 5,
      },
      qtlxfs: false,
      total: 0,
      formData: {},
      activities: [],
      selectedData: [],
      franchisee: false,
      tableData: [],
      dialogVisible: false,
      otherServePerson: false,
      volunteer: false,
      normalInfo: {},
      tableProject: [],
      setpInfo: [],
      orderList: [
        { value: "7", label: "商业服务工单" },
        { value: "3", label: "残联服务工单" },
        { value: "4", label: "老干服务工单" },
        { value: "6", label: "民政服务工单" },
        { value: "10", label: "文明办服务工单" },
        { value: "14", label: "退役军人服务工单" },
      ],
    }
  },
  created() {
    // this.getProjectList()
  },
  watch: {
    formData: {
      handler(val) {
        if (this.formData.phone) {
          this.getTableData()
        }

        if (val.hide) {
          this.query = {
            pageNo: 1,
            pageSize: 5,
          }
          this.total = 0
          this.activities = []
          this.tableData = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 菜单显示
    infoTap(num) {
      this.displayIndex = num
    },
    getProjectList(ids) {
      let self = this
      return new Promise((resolve, reject) => {
        let params = {
          pageNo: 1,
          pageSize: 99,
          // status: "1",
          ids: ids,
        }
        request({
          url: "/jjyl/admin/product/info/findByIds",
          method: "POST",
          data: params,
        }).then((res) => {
          if (res.code === 200 && res.content) {
            this.tableProject = []
            if (this.showTitle != "查看") {
              this.tableProject = res.content.filter((item) => {
                return item.delFlag1 == "0"
              })
            } else {
              if (aff) {
                res.content.forEach((item) => {
                  for (let i = 0; i < aff.length; i++) {
                    if (item.id == aff[i]) {
                      this.tableProject.push(item)
                    }
                  }
                })
              }
            }
            resolve(this.tableProject)
          } else {
            resolve([])
          }
          // if (res.code === 200 && res.content) {
          //     let tableProject = res.content || []
          //     resolve(tableProject)
          // } else {
          //     resolve([])
          // }
        })
      }).catch((err) => {})
    },
    // 获取套餐类型列表
    getEnsureList() {
      request({
        url: "/jjyl/admin/meal/info/findList1",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          states: "1",
          id: this.normalInfo.ensure,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content.list || []
          arr.forEach((item) => {
            item.id = item.id + ""
          })
          this.ensureList = arr.filter((item) => {
            return item.states == "1"
          })
        }
      })
    },
    otherTelephone() {},

    // 获取服务种类
    getServiceTypeList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content.list || []
          // 过滤开启状态的服务种类
          this.serviceTypeList = arr.filter((item) => {
            return item.status == 1
          })
        } else {
          this.$message.error("获取服务种类失败")
        }
      })
    },
    // 选择服务项目
    inputClickChanPin() {
      // if (this.showTitle === '查看') return
      if (!this.formData.serviceType) {
        this.$message.error("请先选择服务种类")
        return
      }
      this.showChanpin = true
      this.$refs.ChanPinList && this.$refs.ChanPinList.getDataList()
    },
    clearData() {
      this.templateRadio = ""
      this.$refs.multipleTable.clearSelection()
      this.query.pageNo = 1
      this.getTableData()
    },
    getTableData() {
      const data = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
        customerName: this.formData.customerName,
        customer: this.formData.customer,
        states: 3,
        custome: this.formData.id,
      }
      this.$post("/jjyl/servicePgd/info/findServicepgd", data).then((res) => {
        console.log(res)
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list
            this.total = res.content.count
          } else {
            this.tableData = []
            this.total = 0
          }
        }
      })
    },
    // handleSelectionChange(val) {
    //   this.multipleSelection = val
    //   if (val.length > 1) {
    //     this.$refs.myTable.clearSelection()
    //     this.$refs.myTable.toggleRowSelection(val.pop())
    //   }
    // },
    getTemplateRow(index, row) {
      //获取选中数据
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getTableData()
    },
    detailsRecord() {
      const self = this
      if (this.templateRadio) {
        self.normalInfo = {}
        request({
          url: "/jjyl/servicePgd/info/findServicepgdById",
          method: "POST",
          data: {
            id: self.templateRadio,
          },
        }).then((res) => {
          if (res.code === 200) {
            self.normalInfo = res.content == null ? {} : res.content
            if (this.normalInfo.ensure) {
              this.normalInfo.ensure = Number(this.normalInfo.ensure)
            }
            if (self.normalInfo.serveproductName !== null) {
              let aff = self.normalInfo.serveproductName.split(",")
              self.getProjectList(aff).then((res) => {
                this.tableProject = res
                let idF = []
                if (aff.length > 0) {
                  aff.forEach((item) => {
                    self.tableProject.forEach((it) => {
                      if (item == it.id) {
                        idF.push(it.id)
                      }
                    })
                  })
                  self.normalInfo.serveproductName = idF
                } else {
                  self.normalInfo.serveproductName = []
                }
              })
            } else {
              self.normalInfo.serveproductName = []
            }
            self.normalInfo.otherTelephone =
              self.normalInfo.familyPhone == null ? "2" : "1"
            self.normalInfo.franchisee =
              self.normalInfo.jiamengEstimate == null ? "否" : "是"
            self.normalInfo.volunteer =
              self.normalInfo.otherReturnContent == null ? "否" : "是"
            self.normalInfo.otherPerson =
              self.normalInfo.otherservePersonName == null ? "否" : "是"

            self.normalInfo.statType = "0"

            self.getNoraml(res.content)
            this.getEnsureList()
          }

          // normalInfo setpInfo
        })
      } else {
        this.$message.warning("请选择要查看的工单")
      }
    },
    // 查看异常
    getNoraml(data) {
      const self = this
      self.currIndex = false
      request({
        url: "/jjyl/servicePgdLog/info/findList",
        // url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: {
          servicePgdId: data.id,
          pageNo: 1,
          pageSize: -1,
        },
        // data: {
        //     exceptionType: 2,
        //     pageNo: 1,
        //     pageSize: 10,
        //     states: 7,
        //     orderNum: data.orderNum,
        // },
      }).then((resp) => {
        if (resp.code == "200") {
          // currIndex: 0,
          let datas = []
          if (resp.content) {
            if (resp.content.list) {
              resp.content.list.forEach((item, index) => {
                if (item.states == 0) {
                  let ensureName = "",
                    pgdtypeName = ""
                  if (item.ensure) {
                    self.ensureList.forEach((it) => {
                      if (it.id == item.ensure) {
                        ensureName = it.mealType
                      }
                    })
                  } else {
                    ensureName = ""
                  }
                  if (item.customerType) {
                    self.orderList.forEach((it) => {
                      if (it.value == item.customerType) {
                        pgdtypeName = it.label
                      }
                    })
                  } else {
                    pgdtypeName = ""
                  }
                  datas.push({
                    states: item.states,
                    currIndex: self.currIndex == false ? false : true,
                    createTime: item.createTime,
                    ensureName: ensureName,
                    pgdtypeName: pgdtypeName,
                  })
                } else if (item.states == 10) {
                  datas.push({
                    states: item.states,
                    currIndex: self.currIndex == false ? false : true,
                    palnTimeStart: item.createTime,
                    servePersonName: item.servePersonName,
                  })
                } else if (item.states == 11) {
                  datas.push({
                    states: item.states,
                    currIndex: self.currIndex == false ? false : true,
                    palnTimeEnd: item.createTime,
                    period: item.period,
                    visitContent: item.visitContent,
                  })
                } else if (item.states == 7) {
                  self.currIndex = true
                  let exceptionStatusName = ""
                  if (item.exceptionStatus == 1) {
                    exceptionStatusName = "位置异常"
                  } else if (item.exceptionStatus == 2) {
                    exceptionStatusName = "时间异常"
                  } else if (item.exceptionStatus == 3) {
                    exceptionStatusName = "位置异常、时间异常"
                  } else if (item.exceptionStatus == 4) {
                    exceptionStatusName = "回访异常"
                  } else if (item.exceptionStatus == 5) {
                    exceptionStatusName = "位置异常、回访异常"
                  } else if (item.exceptionStatus == 6) {
                    exceptionStatusName = "时间异常、回访异常"
                  } else if (item.exceptionStatus == 7) {
                    exceptionStatusName = "位置异常 时间异常 回访异常"
                  }

                  datas.push({
                    states: item.states,

                    currIndex: self.currIndex == false ? false : true,
                    exceptionStatusName: exceptionStatusName,
                  })
                } else if (item.states == 13) {
                  let processStatusName = ""
                  if (item.processStatus == 1) {
                    processStatusName = "回退"
                  } else if (item.processStatus == 2) {
                    processStatusName = "完成"
                  } else if (item.processStatus == 3) {
                    processStatusName = "改派"
                  }
                  datas.push({
                    states: item.states,
                    currIndex: self.currIndex == false ? false : true,
                    processStatusName: processStatusName,
                    createTime: item.createTime,
                    createdId: item.createName,
                  })
                } else if (item.states == 14) {
                  let estimateLevelName = "",
                    resultsName = ""

                  self.estimateLevelList.forEach((it) => {
                    if (it.value == item.estimateLevel) {
                      estimateLevelName = it.label
                    }
                  })
                  if (item.visitResults == 0) {
                    resultsName = "合格"
                  } else if (item.visitResults == 1) {
                    resultsName = "不合格"
                  } else if (item.visitResults == 2) {
                    resultsName = "作废"
                  } else if (item.visitResults == 3) {
                    resultsName = "虚假工单"
                  }
                  datas.push({
                    states: item.states,
                    currIndex: self.currIndex == false ? false : true,
                    callTime: item.createTime,
                    resultsName: resultsName,
                    estimateLevelName: estimateLevelName,
                  })
                }
              })
              self.setpInfo = datas
            } else {
              self.setpInfo = []
            }
          } else {
            self.setpInfo = []
          }
          self.dialogVisible = true
        }
      })
    },

    deleteilsRecord() {
      // const id = this.multipleSelection[0].id
      // this.$set(this.formData, "id", id)
      var that = this
      var val = this.templateRadio
      if (val != "") {
        this.$confirm("确认是否废除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$refs.multipleTable.clearSelection()
        })
      } else {
        this.$message.warning("请选择要废除的项。")
      }
    },
  },
}
</script>

<style lang="less" scoped>
.ser-1 {
  width: 98%;
  margin-left: 2%;
  position: absolute;
}

.record-1 {
  width: 80%;
  display: flex;
  justify-content: space-between;
}

.record-2 {
  display: flex;
}

.record-2 > div {
  margin-right: 20px;
}

.record-3 {
  width: 100%;
  margin: 20px 0;
  position: relative;
}

.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.dia-1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.dia-2 {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.dia-2 > div:first-child {
  width: 150px;
  text-align: right;
  padding-right: 20px;
}

.dia-4 {
  width: 380px;
  background-color: #f2f2f2;
  border-radius: 44px;
  padding: 20px 0;
  height: 400px;
  overflow-y: scroll;
}
.recondItem {
  position: relative;
  padding: 10px;
  .recondeLine {
    background: #76a0f6;
    position: absolute;
    left: 18px;
    top: 13px;
    right: 60px;
    height: 4px;
    z-index: 1;
    &.recondeLine1 {
      background: #ff0000;
    }
  }
  .recondeDot {
    position: absolute;
    left: 10px;
    background: #76a0f6;
    top: 12px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    &.recondeDot1 {
      background: #ff0000;
    }
  }
  .recondeBgs {
    position: relative;
    z-index: 4;
    height: 220px;
    background: url(../../assets/img/cat1.png) no-repeat right top;
    &.recondeBg1 {
      background: url(../../assets/img/catRed.png) no-repeat right top;
    }
    .recondeTitle {
      position: absolute;
      color: #fff;
      font-size: 16px;
      top: 0px;
      width: 120px;
      text-align: center;
      right: 50px;
      line-height: 30px;
    }
    .recondeUl {
      position: absolute;
      right: 16px;
      top: 77px;
      width: 184px;
      line-height: 30px;
      color: #909090;
      font-size: 14px;
    }
  }
  .recondeBg {
    position: relative;
    z-index: 4;
    height: 220px;
    background: url(../../assets/img/cat.png) no-repeat right top;
    &.recondeBg1 {
      background: url(../../assets/img/catRed.png) no-repeat right top;
    }
    .recondeTitle {
      position: absolute;
      color: #fff;
      font-size: 16px;
      top: 7px;
      width: 120px;
      text-align: center;
      right: 50px;
      line-height: 30px;
    }
    .recondeUl {
      position: absolute;
      right: 16px;
      top: 77px;
      width: 184px;
      line-height: 30px;
      color: #909090;
      font-size: 14px;
    }
  }
}
.navMenu {
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
}
.desBox {
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
}
.phoneCall {
  cursor: pointer;
  padding: 0 5px;
}
</style>
